import { render } from "./TokenTimer.vue?vue&type=template&id=3e528ff0&scoped=true"
import script from "./TokenTimer.vue?vue&type=script&lang=js"
export * from "./TokenTimer.vue?vue&type=script&lang=js"

import "./TokenTimer.vue?vue&type=style&index=0&id=3e528ff0&scoped=true&lang=css"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e528ff0"]])

export default __exports__